import styled from "styled-components";
import { comingSoonSvg } from "../../components/Assets";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 20px;
  gap: 24px;
`;
export default function CommingSoon({title, desc, lsDesc}) {
  const ls = [...(lsDesc ?? []), desc].filter(x=>x);
  return (
    <Box style={{
      height: "calc(100vh - 300px)",
    }}>
      <img src={comingSoonSvg}></img>
      <p className="flex flex-col gap-2">
        <b className="text-lg text-center">{title}</b>
        <span className="flex flex-col">
          {
            ls.map(x => {
              return <span key={x} dangerouslySetInnerHTML={{ __html: x }} className="text-center" />
            })
          }          
        </span>
      </p>
    </Box>
  );
}
